import "core-js/features/array/flat-map"
import React from "react"
import { Provider } from "react-redux"
import { hydrate, render } from "react-dom"
import { configureStore } from "./Config/Store"
import { App } from "./App"
import * as serviceWorker from "./Config/ServiceWorker"
import { MainAction, State } from "./Reducers"
import { Store } from "redux"
import { createBrowserHistory } from "history"
import { initActors } from "./Actors"
import * as Sentry from "@sentry/react"
import { config } from "bridger"

Sentry.init(config.dash.sentry)

// Unnessary for current version
serviceWorker.unregister()
// Set up router
const history = createBrowserHistory()
// Create redux store
const store: Store<State, MainAction> = configureStore(history)()
const actors = initActors()
store.subscribe(() => {
    actors(store.getState(), store.dispatch)
})

// Pass store and router into app, mount DOM
export const main = () => {
    const rootElement = document.querySelector<HTMLDivElement>("#root")
    const app = (
        <Provider store={store}>
            <App history={history} />
        </Provider>
    )
    if (rootElement !== null && rootElement.hasChildNodes()) {
        hydrate(app, rootElement)
    } else {
        render(app, rootElement)
    }
}

main()

// Dev only hot reloading
if (process.env.NODE_ENV !== "production" && (module as any).hot) {
    ;(module as any).hot.accept("./App", main)
}
